import {
  AutomationMajor,
  CancelMajor,
  CartMajor,
  OrdersMajor,
  ShipmentMajor,
  SmileyJoyMajor,
  StatusActiveMajor,
  StoreMajor,
} from "@shopify/polaris-icons";

export const getAutomationTypeIcon = (automationType) => {
  var automationTypeIcon = AutomationMajor;
  if (
    automationType === "abandoned-cart" ||
    automationType === "just-abandoned-checkout"
  ) {
    automationTypeIcon = CartMajor;
  } else if (automationType === "back-in-stock") {
    automationTypeIcon = StoreMajor;
  } else if (automationType === "order-confirmation") {
    automationTypeIcon = OrdersMajor;
  } else if (automationType === "order-tracking") {
    automationTypeIcon = ShipmentMajor;
  } else if (automationType === "optin-confirmation") {
    automationTypeIcon = SmileyJoyMajor;
  }
  return automationTypeIcon;
};

export const getAutomationStatus = (automation) => {
  var isAutomationActive = false;
  var automationStatusIcon = CancelMajor;
  if (!automation?.automationType || !automation.customer) {
    return { isAutomationActive: null, automationStatusIcon: null };
  }
  if (
    ((automation.automationType === "abandoned-cart" ||
      automation.automationType === "just-abandoned-checkout") &&
      automation.customer.abandonedCartCampaignId === automation.id) ||
    (automation.automationType === "back-in-stock" &&
      automation.customer.backInStockCampaignId === automation.id) ||
    (automation.automationType === "order-confirmation" &&
      automation.customer.orderConfirmationCampaignId === automation.id) ||
    (automation.automationType === "order-tracking" &&
      automation.customer.orderTrackingCampaignId === automation.id) ||
    (automation.automationType === "optin-confirmation" &&
      automation.customer.optinConfirmationCampaignId === automation.id)
  ) {
    isAutomationActive = true;
    automationStatusIcon = StatusActiveMajor;
  } else {
    isAutomationActive = automation.isAutomationActive;
  }
  return {
    isAutomationActive,
    automationStatusIcon,
  };
};
